<div class="ig-modal">
    <mat-icon class="close-icon" (click)="close()">
        close
    </mat-icon>

    <mat-icon class="main-icon error">error_outline</mat-icon>

    <div class="error-detail" *ngIf="!!errorResponse">
        <div *ngIf="errorResponse.status">
            {{errorResponse.status}}
        </div>

        <div>
            {{errorResponse.message}}
        </div>
    </div>

    <ig-button (trigger)="close()"
                size="md">
        Ok
    </ig-button>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/error.modal/error.handler.modal.component.html